// extracted by mini-css-extract-plugin
module.exports = {"main-image":"styles-module__main-image___2bPEG","main-image-large":"styles-module__main-image-large___3PM2N"};